import React from 'react';
import { Animated, View, Text } from 'react-native';
import i18n from 'i18n-js';

import { isPhone, isPhoneNative, isWeb, LEVELS } from '@helpers';
import { scale as initialScale, notchTop, width } from '@components/frame';

import useStatusBar from '@components/common/useStatusBar';

import ColorWrapper from '@styles/colors';
import { font as initialFont } from '@styles/fonts';
import TouchableElement from '@components/common/touchableElement';
import BackButton from '@components/common/backButton';

import SearchInput from '@components/common/searchInput';
import Suggestion from '@components/search/components/suggestion';
import { ModeSelector, TableTools } from '@components/search/components/toolbar';
import { SearchInputWithModeSelector } from '@components/search/components/SearchInputWithModeSelector';
import { useDeviceSize } from '@v2/pages/common/hooks/useDeviceSize';
import { SCREEN_PADDING_HORIZONTAL } from '@v2/pages/common/constants/base.constants';
import { shouldShowModeSelector, shouldShowSuggestionsPanel } from './helpers';

const Header = (props) => {
  const {
    C,
    fadeAnim,
    searchRef,
    cancelAnimation,
    suggestion,
    name,
    changeLevel,
    level,
    onSearch,
    setSuggestion,
    setSelectedNCFile,
    totalSearchResult,
    loaded,
    isError,
    displayMode,
    setSelectedDisplayMode,
    apiRef,
    isRefReady,
    isTableMode,
    customAnchorRef,
    isWithERP,
    inputName,
    searchValue,
    submit,
    disabledModes,
    searchInputWithModeSelectorStyle,
    searchInputViewSelectorBg,
    showModeSelectorInPopupMode,
    isPopupMode = false,
    scale = initialScale,
    font = initialFont,
  } = props;

  if (!isPopupMode) {
    useStatusBar({ C });
  }
  const { IS_NARROW_WEB } = useDeviceSize();

  const isAllLevel = level === LEVELS.ALL;
  const showModeSelector = shouldShowModeSelector(level);

  const shouldShowSuggestions = shouldShowSuggestionsPanel({
    isPopupMode,
    suggestionLength: suggestion.length,
    isWeb,
    isNarrowWeb: IS_NARROW_WEB,
    isPhone,
  });

  return (
    <Animated.View
      style={[
        {
          flex: 1,
          marginTop: isPopupMode
            ? 0
            : isWeb
            ? 20
            : fadeAnim.interpolate({
                inputRange: [0, 1],
                outputRange: [-scale(20), isPhone ? scale(notchTop) : 50],
              }),
          zIndex: 10000000,
        },
      ]}
    >
      {!isPopupMode && isPhone && !IS_NARROW_WEB && (
        <Animated.View
          style={{
            marginBottom: scale(16),
            opacity:
              LEVELS.ALL === level || isWeb
                ? 0
                : fadeAnim.interpolate({
                    inputRange: [0, 1],
                    outputRange: [0, 1],
                  }),
          }}
        >
          <BackButton onPress={() => changeLevel(LEVELS.ALL)} top={0} padding={0} />
        </Animated.View>
      )}
      <Animated.View
        style={[
          {
            marginHorizontal: scale(SCREEN_PADDING_HORIZONTAL),
            marginBottom: scale(18),
            zIndex: 1000000,
          },
        ]}
      >
        {!isPopupMode && (
          <Animated.View
            style={{
              marginTop: scale(2),
              opacity: isWeb
                ? 1
                : fadeAnim.interpolate({
                    inputRange: [0, 1],
                    outputRange: [0, 1],
                  }),
            }}
          >
            <Text style={[font['Body'], { color: C('Label/Light/Tertiary'), marginRight: scale(20), opacity: isAllLevel ? 0 : 1 }]}>
              {loaded && !isError ? totalSearchResult : ''} {i18n.t('FOUND')}
            </Text>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
              <Text style={[font['Large Title'], { color: C('Label / Light / Primary') }]}>{name}</Text>
              <TableTools
                style={{ alignSelf: 'flex-end', flexDirection: 'row', gap: scale(20) }}
                ref={customAnchorRef}
                {...{ apiRef, C, isRefReady, isTableMode, level, isWithERP }}
              />
            </View>
          </Animated.View>
        )}
        <SearchInputWithModeSelector
          {...{
            C,
            cancelAnimation,
            displayMode,
            inputName,
            level,
            onSearch,
            searchRef,
            searchValue,
            setSelectedDisplayMode,
            showModeSelector,
            submit,
            isPopupMode,
            scale,
            font,
            disabledModes,
            searchInputWithModeSelectorStyle,
            showModeSelectorInPopupMode,
            bg: searchInputViewSelectorBg,
          }}
        />
      </Animated.View>
    </Animated.View>
  );
};

export default ColorWrapper(Header);
